/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type StageEntityTypeEnum = "containers" | "shipments" | "%future added value";
export type infoUnpickEntityStageInput = {
    clientMutationId?: string | null;
    entityType: StageEntityTypeEnum;
    entitySlug: string;
    stage?: string | null;
};
export type ShipmentWorkflowUnpickStageMutationVariables = {
    input: infoUnpickEntityStageInput;
};
export type ShipmentWorkflowUnpickStageMutationResponse = {
    readonly infoUnpickEntityStage: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ShipmentWorkflowUnpickStageMutation = {
    readonly response: ShipmentWorkflowUnpickStageMutationResponse;
    readonly variables: ShipmentWorkflowUnpickStageMutationVariables;
};



/*
mutation ShipmentWorkflowUnpickStageMutation(
  $input: infoUnpickEntityStageInput!
) {
  infoUnpickEntityStage(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoUnpickEntityStagePayload",
    "kind": "LinkedField",
    "name": "infoUnpickEntityStage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShipmentWorkflowUnpickStageMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShipmentWorkflowUnpickStageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ecddfa94781457a5c9b69e138cc04950",
    "id": null,
    "metadata": {},
    "name": "ShipmentWorkflowUnpickStageMutation",
    "operationKind": "mutation",
    "text": "mutation ShipmentWorkflowUnpickStageMutation(\n  $input: infoUnpickEntityStageInput!\n) {\n  infoUnpickEntityStage(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'cd098fb7a088f834f7938061b7c901e5';
export default node;
